import { render, staticRenderFns } from "./posterPlace.vue?vue&type=template&id=1cfc2756&scoped=true&"
import script from "./posterPlace.vue?vue&type=script&lang=js&"
export * from "./posterPlace.vue?vue&type=script&lang=js&"
import style0 from "./posterPlace.vue?vue&type=style&index=0&id=1cfc2756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc2756",
  null
  
)

export default component.exports